import { useEditRequestFormContext } from "@/features/request/edit/hooks/useEditRequestForm";

const EMPTY_HTML_VALUES = new Set(["", "<p></p>"]);

function isNonEmptyHtml(value: null | string | undefined): boolean {
  if (!value) return false;

  return !EMPTY_HTML_VALUES.has(value.trim());
}

export function useIsMBC(): boolean {
  const { watch } = useEditRequestFormContext();
  const briefText = watch("briefText");

  return isNonEmptyHtml(briefText);
}
